import request from '@/axios'
import { download } from '@/axios/request'

export const supplement = (data) => {
  return request({
    url: '/lebo-member/web/memberNew/order/applySupplement',
    method: 'post',
    data
  })
}

export const applyRefund = (data) => {
  return request({
    url: '/lebo-member/web/memberNew/order/applyRefund',
    method: 'post',
    data
  })
}


export const orderList = (data) => {
  return request({
    url: '/lebo-member/web/memberNew/order/page',
    method: 'get',
    params: data
  })
}


/** 系统字典获取支付方式描述 */
export const info = (data) => {
  return request({
    url: "/lebo-member/web/memberNew/order/info",
    method: "GET",
    params: data
  });
};

/** 系统字典获取支付方式描述 */
export const getPayTypeList = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=pay_type_desc",
    method: "GET"
  });
};

/** 系统字典获取商户列表描述 */
export const getMerchantList = () => {
  return request({
    url: "/lebo-member/web/memberNew/order/getMerchantList",
    method: "GET"
  });
};

/** 系统字典获取退款原因类型描述 */
export const getRefundReasonTypeList = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=refund_reason_type",
    method: "GET"
  });
};

/** 系统字典获取业务类型描述 */
export const getBusinessTypeList = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=order_business_type",
    method: "GET"
  });
};

/** 获取订单商品类型描述 */
export const getMtypeList = () => {
  // return request({
  //   url: "/lebo-system/dict/dictionary?code=order_mtype",
  //   method: "GET"
  // });
  return request({
    url: "/lebo-member/web/memberNew/order/queryAllServerTypeList",
    method: "GET"
  });
};

/** 获取商品列表 */
export const queryAllProductList = () => {
  return request({
    url: "/lebo-member/web/memberNew/order/queryAllProductList",
    method: "GET"
  });
};

// 导出退款/补单
export const exportOrderList = (data) => {
  download('/lebo-member/web/memberNew/order/exportExcel', data)
}

/** 获取渠道列表 */
export const getSimpleChannelAllListBytid = () => {
  return request({
    url: "/lebo-member/web/memberNew/order/getSimpleChannelAllListBytid",
    method: "GET"
  });
};

/** 抖店退回权益 */
export const refundRightInDoudian = (data) => {
  return request({
    url: "/lebo-member/web/memberNew/order/refundRightInDoudian",
    method: "POST",
    data
  });
};

/** iOS 线下退款确认 */
export const iosApplyRefund = (data) => {
  return request({
    url: "/lebo-member/web/memberNew/order/iosApplyRefund",
    method: "POST",
    data
  });
};

